/* Shell colour dots on product cards (snippets/ol-card-shell-swatches.liquid).
   Hover or focus a dot to preview that shell; click or tap to keep it (the card links then open that colour).
   One set of listeners on the document, so cards added later by the filters work too. */
(function () {
  if (window.olCardShellSwatches) return;
  window.olCardShellSwatches = true;

  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function card(el) { return el.closest('.product.home-products__item, .product'); }
  function img(c) { return c && c.querySelector('.product__img'); }

  function remember(c) {
    var i = img(c);
    if (!i || c._olCs) return;
    c._olCs = {
      src: i.getAttribute('data-src') || i.getAttribute('src') || '',
      srcset: i.getAttribute('data-srcset') || i.getAttribute('srcset') || '',
      alt: i.getAttribute('alt') || '',
      links: Array.prototype.map.call(c.querySelectorAll('a.js-product-link'), function (a) { return a.getAttribute('href'); })
    };
  }

  function show(c, src, srcset, alt) {
    var i = img(c);
    if (!i || !src) return;
    i.setAttribute('data-src', src);
    i.setAttribute('data-srcset', srcset);
    if (i.classList.contains('lazyloaded') || i.getAttribute('src')) {
      i.setAttribute('srcset', srcset);
      i.setAttribute('src', src);
    }
    if (alt) i.setAttribute('alt', alt);
  }

  function label(c, text) {
    var n = c.querySelector('.ol-cs__name');
    if (n) n.textContent = text || '';
    var g = c.querySelector('.ol-cs');
    if (g) g.classList.toggle('has-name', !!text);
  }

  function preview(dot) {
    var c = card(dot); if (!c) return;
    remember(c);
    show(c, dot.getAttribute('data-src'), dot.getAttribute('data-srcset'), dot.getAttribute('data-alt'));
    label(c, dot.getAttribute('data-name'));
  }

  function restore(c) {
    var on = c.querySelector('.ol-cs__dot.is-on');
    if (on) {
      show(c, on.getAttribute('data-src'), on.getAttribute('data-srcset'), on.getAttribute('data-alt'));
    } else if (c._olCs) {
      show(c, c._olCs.src, c._olCs.srcset, c._olCs.alt);
    }
    label(c, '');
  }

  function choose(dot) {
    var c = card(dot); if (!c) return;
    remember(c);
    Array.prototype.forEach.call(c.querySelectorAll('.ol-cs__dot'), function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    show(c, dot.getAttribute('data-src'), dot.getAttribute('data-srcset'), dot.getAttribute('data-alt'));
    var url = dot.getAttribute('data-url');
    if (url) Array.prototype.forEach.call(c.querySelectorAll('a.js-product-link'), function (a) { a.setAttribute('href', url); });
    if (touch) {
      label(c, dot.getAttribute('data-name'));
      clearTimeout(c._olCsT);
      c._olCsT = setTimeout(function () { label(c, ''); }, 2200);
    }
  }

  var warmed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function warm(group) {
    if (!warmed || warmed.has(group)) return;
    warmed.add(group);
    Array.prototype.forEach.call(group.querySelectorAll('.ol-cs__dot'), function (d) {
      var p = new Image(); p.src = d.getAttribute('data-src');
    });
  }

  /* Sit the dots at the right-hand end of the card's price box. Measured with offsetTop/offsetLeft, so the
     card's hover zoom does not throw the numbers out. The price text gets room on its right so they never touch. */
  function offsetIn(el, root) {
    var x = 0, y = 0, e = el;
    while (e && e !== root) { x += e.offsetLeft; y += e.offsetTop; e = e.offsetParent; }
    return e === root ? { x: x, y: y } : null;
  }
  function place(g) {
    var c = card(g); if (!c) return;
    var box = c.querySelector('.price-container');
    var price = box && box.querySelector('.product__price');
    var o = box && offsetIn(box, c);
    if (!o || !box.offsetWidth) { g.style.top = ''; g.style.right = ''; g.classList.add('is-placed'); return; }
    if (price) {
      // the price box is a flex row: let the price shrink and wrap (sale price drops to a second line) instead of running under the dots
      price.style.paddingRight = (g.offsetWidth + 12) + 'px';
      price.style.minWidth = '0';
      price.style.flex = '1 1 auto';
    }
    var right = c.offsetWidth - (o.x + box.offsetWidth) + 8;
    var top = o.y + (box.offsetHeight - g.offsetHeight) / 2;
    g.style.right = Math.round(right) + 'px';
    g.style.top = Math.round(top) + 'px';
    g.classList.add('is-placed');
  }
  function placeAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-ol-cs]'), place); }
  var pt;
  function later() { clearTimeout(pt); pt = setTimeout(placeAll, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  window.addEventListener('load', later);
  window.addEventListener('resize', later);
  if (window.MutationObserver) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes.length) { later(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (!touch) {
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest && e.target.closest('.ol-cs__dot');
      var g = e.target.closest && e.target.closest('[data-ol-cs]');
      if (g) warm(g);
      if (dot) preview(dot);
    });
    document.addEventListener('mouseout', function (e) {
      var g = e.target.closest && e.target.closest('[data-ol-cs]');
      if (!g) return;
      if (e.relatedTarget && g.contains(e.relatedTarget)) return;
      restore(card(g));
    });
  }
  document.addEventListener('focusin', function (e) {
    var dot = e.target.closest && e.target.closest('.ol-cs__dot');
    if (dot && !touch) preview(dot);
  });
  document.addEventListener('focusout', function (e) {
    var g = e.target.closest && e.target.closest('[data-ol-cs]');
    if (!g || touch) return;
    if (e.relatedTarget && g.contains(e.relatedTarget)) return;
    restore(card(g));
  });
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ol-cs__dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    choose(dot);
  }, true);
})();
